import $ from 'jquery'
import 'bootstrap'
import 'bootstrap4-toggle'
import { registerReactControllerComponents } from '@symfony/ux-react'

import '../sentry' // First code after third party imports so every error is caught.

import '../../stimulus_bootstrap' // Symfony UX: starts Stimulus, loads controllers from Assets/controllers

import { initHamburgerMenu } from '../hamburgers'
import { initHeaderNav } from '../headerNav'
import { initHeaderOnScroll } from '../header'
import { initPasswordToggleInputs } from '../passwordInput'
import { initPasswordStrength } from '../passwordStrength'
import { initToolTips } from '../tooltip'
import { registerExtensions } from '../extensions'
import { initScrollUpButton } from '../scrollUpButton'
import initSliders from '../slider/rangeslider'
import { initCarouselSelector } from '../carouselSelector'
import { initInstallmentSelector } from '../installmentSelector'
import initDatePickers from '../dateTime/datePicker'
import initReCaptcha from '../form/recaptcha'
import initValidations from '../validation/validator'
import { initLabelTriggerCustomCheckbox } from '../shared'
import { initNumberInputs } from '../numberInput'

registerExtensions() // jQuery and other window.fn extensions
registerReactControllerComponents(require.context('../../jsx/controllers', true, /\.(j|t)sx?$/)) // Symfony UX React components
initSliders()

$(() => {
    initDatePickers() // DatePickers
    initValidations() // Validations
    initReCaptcha() // Invisible reCAPTCHA Enterprise token minting
    initHamburgerMenu() // Client-area side menu
    initHeaderNav() // Web header nav (dropdowns, burger drawer)
    initHeaderOnScroll() // Header
    initToolTips() // Tooltips
    initPasswordToggleInputs() // Password ShowToggle
    initPasswordStrength() // Password strength checklist
    initScrollUpButton() // scroll up button in the footer
    initCarouselSelector()
    initInstallmentSelector()
    initLabelTriggerCustomCheckbox() // trigger for custom checkboxes
    initNumberInputs() // Block 'e' and 'E' in <input type="number">
})
